const drivingLicenses = [
  { name: "AM (Moped)", value: "AM" },
  { name: "A1", value: "A1" },
  { name: "A2", value: "A2" },
  { name: "A (Motorcycle)", value: "A" },
  { name: "B (Car)", value: "B" },
  { name: "C (Truck)", value: "C" },
  { name: "D (Bus)", value: "D" },
  { name: "E (Trailer)", value: "E" },
];

export default drivingLicenses;
